<template>
    <div class="">
		<h1 class="text-muted mb-4">
            <vue-fontawesome class="mr-2" icon="money"></vue-fontawesome>
            <router-link class="ml-2 text-decoration-none"
                :to="{ name: `stock`, query: { destroy : destroy }}">
                <i class="ml-2 arrow left" style="height:25px;width:25px"></i>
                Purchases
            </router-link>
            / receive purchase
        </h1>
        <!-- view, add and edit modal -->
        <section>
			<div>
				<ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
					<li class="nav-item">
						<a class="d-none nav-link active"
							id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">
							Basic
						</a>
					</li>
				</ul>
				<div class="tab-content" id="pills-tabContent">
					<div class="tab-pane fade"
						id="pills-home"
						role="tabpanel"
						aria-labelledby="pills-home-tab">
						Home
					</div>
					<div class="tab-pane fade show active" id="pills-products" role="tabpanel" aria-labelledby="pills-products-tab">
						<div class="d-flex">
							<section class="col-lg-12">
								<div class="d-flex justify-content-end ">
									<ul class="nav nav-pills mb-3 w-50" id="pills-tab" role="tablist">
										<li class="nav-item d-flex" v-for="basket in open_baskets" :key="basket.id">
											<a class="nav-link active d-flex justify-content-center"
												data-toggle="pill"
												:href="`#pills-basket-${basket.id}`"
												role="tab"
												:aria-controls="`pills-basket-${basket.id}`"
												style="font-size: 20px"
												aria-selected="false"
												@click="active_basket = basket.id">
												<div class="input-group">
													<div class="input-group-prepend">
														<vue-fontawesome class="mr-1 ml-3 mt-2" icon="truck"></vue-fontawesome>
													</div>
													<select class="form-control" v-model="supplier">
														<option value="nullS" selected default>
														--- choose supplier ---
														</option>
														<option :value="supplier" v-for="(supplier,index) in suppliers" :key="index">
																{{supplier.name}} ( {{supplier.address}} )
														</option>
													</select>
												</div>
												<vue-fontawesome class="mr-1 ml-3 mt-2" icon="map-marker"></vue-fontawesome>
												<select class="form-control" v-model="location">
													<option selected default>
														--- choose location ---
													</option>
													<option v-for="(location,index) in locations" :key="index" :value="location">
														{{location.name}}
													</option>
												</select>

											</a>
										</li>
									</ul>
									<div class="p-2">
										<button type="button" name="button" class="btn btn-success" @click="openProductsModal">Select products</button>
									</div>
								</div>
								<!-- customer basket tabs content-->
								<div class="tab-content" id="pills-tabContent">
									<div v-if="! supplier" class="text-muted d-flex justify-content-center mt-5">
										No supplier chosen <br>
										select a supplier from above to receive items from them
									</div>
									<div class="tab-pane fade show active"
										v-for="basket in open_baskets" :key="basket.id"
										:id="`pills-basket-${basket.id}`"
										role="tabpanel" >
										<div class="p-2" style="max-height: 35vh; overflow-y:scroll" id="selectedProducts">
											<table class="table table-borderless">
												<thead>
													<tr>
													<th scope="col">product</th>
													<th scope="col">quantity</th>
													<th scope="col">purchase price</th>
													<th></th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(product,index) in basket.products" :key="index"
														:id="`basket-item-${product.id}`">
														<td v-if="product.product">
															<div>
																{{product.product.name}}<br/>
																<small v-if="product.selection.variant">
																	{{product.selection.variant.variant}} - {{product.selection.variant.value}}
																</small>
															</div>
														</td>
														<td v-if="product.product">
															<div>
																<input type="number"
																class="form-control"
																style="max-width:70px"
																v-model="product.selection.quantity">
															</div>
														</td>
														<td v-if="product.product">
															<div>
																{{product.product.purchase_price | intcomma}}
															</div>
														</td>
														<td v-if="product.product">
															<div>
																<i class="delete-button p-2 cursor-pointer"
																	@click="removeProductFromBasket(index)">
																	&times;
																</i>
															</div>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
										<!-- totals -->
										<div class="p-4 d-flex justify-content-end">
											<span class="mr-4 mt-2 font-weight-bold">
												{{basket_stats(basket.id).number_of_items}} items |
											</span>
											<span class="mr-4 mt-2 font-weight-bold">
												totals: Ksh {{basket_stats(basket.id).total |intcomma}}
											</span>
											<button class="btn btn-success"
												data-toggle="modal" data-target="#processPaymentModal"
												@click = "openProcessPaymentModal(basket_stats(basket.id))">
												Process Payment
											</button>
										</div>
									</div>
								</div>
							</section>
						</div>
						<!-- shopping cart -->
					</div>
					<div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">...</div>
				</div>
			</div>
        </section>
		<!-- select location and supplier -->
		<div class="" v-if="!location || !supplier">
			<div class="shadow p-3 border w-50 h-60 bg-white rounded" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
				<div class="" v-if=!supplier >
					<h4>Select supplier</h4>
					<div class="mt-3">
						<a v-for="(supplier,index) in suppliers" :key="index"  class="ml-2 p-3 cursor-pointer mb-2 badge badge-pill badge-light"
							@click="selectSupplier(supplier)">
							{{supplier.name}}
						</a>
					</div>
				</div>
				<div class="" v-if=!location>
					<h4>Select Location</h4>
					<div class="mt-3">
						<a v-for="(location,index) in locations" :key="index" :value="location"  class="ml-2 p-3 cursor-pointer mb-2 badge badge-pill badge-light"
							@click="selectLocation(location)">
							{{location.name}}
						</a>
					</div>
				</div>
			</div>
		</div>
		<div id="productsModal" class="d-none rounded shadow shadow-sm bg-white" style="position:absolute;height:100vh;width:365px;right:0;top:0">
			<div class="p-3 d-flex justify-content-end">
				<button type="button" @click="closeProductsModal" class="close">x</button>
			</div>
			<div class="d-flex justify-content-end">
				<button  type="button" class="btn btn-success" data-toggle="modal" data-target="#addProductModal"
					style="position:absolute; left: 27%;"
					@click="getUnits()">
					+ Add new product
				</button>
			</div>
			<div class="">
				<searchProducts context="purchases" :update_products="update_products" v-on:productPicked="productPicked"/>
			</div>
		</div>
		<div class="modal fade" id="processPaymentModal" tabindex="-1" role="dialog" aria-labelledby="processPaymentModal" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered shodow" role="document">
					<div class="modal-content">
						<div class="modal-header border-0" v-if="receipt_data">
							<h5 class="modal-title" v-if="! purchase_successful">
								Process Payment
								( <small><b>{{receipt_data.number_of_items}}</b> items worth Ksh <b>{{receipt_data.total | intcomma}}</b> </small> )
							</h5>
							<button type="button" id="closeAddPurchasePaymentModal" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<form id="processPaymentForm">
							<div class="modal-body d-flex flex-column justify-content-center" style="min-height: 50vh; overflow-y: scroll"
								v-if="purchase_successful">
								<div class="d-flex justify-content-center">
									<h3 class="text-success">Successful</h3>
								</div>
							</div>
							<div class="modal-body"
								v-if="! purchase_successful">
								<label>Cash</label>
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">amount</label>
									<input type="number" class="col-8 form-control" v-model="payments.cash_amount">
								</div>
								<hr>
								<label>M-pesa</label>
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">amount</label>
									<input type="number" class="col-8 form-control" v-model="payments.mpesa_amount">
								</div>
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">transaction ID</label>
									<input type="text" class="col-8 form-control" v-model="payments.transaction_id">
								</div>
								<hr>
								<label >Credit</label>
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">amount</label>
									<input type="number" class="col-8 form-control" v-model="payments.credit_amount">
								</div>
							</div>
							<div class="modal-footer border-0" v-if="! purchase_successful">
								<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
								<button type="submit" class="btn btn-success"
									@click="makePurchase()">
									Complete
									<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="adding"></span>
								</button>
							</div>
						</form>
					</div>
				</div>
		</div>
		<!-- view purchase details Modal -->
		<button type="button" id="receipt-modal-button" class="d-none btn" data-toggle="modal" data-target="#PurchaseDetailModal">
					Launch receipt modal
		</button>
		<div class="modal fade" id="PurchaseDetailModal" tabindex="-1" role="dialog" aria-labelledby="PurchaseDetailModal" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
			<div class="modal-content" v-if="receipt_modal_data">
				<div class="modal-header">
				<h5 class="modal-title font-weight-bold" >Receipt No. {{receipt_modal_data.id}}</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
				</div>
				<div class="modal-body">
					<div class="d-flex justify-content-between">
						<!-- details -->
						<section class="p-3" style="border-right: solid 1px darkgray ; min-width: 200px;">
							<span class="d-flex flex-column">
								<label class="font-weight-bold">Date:</label>
								<p class="ml-2">{{receipt_modal_data.date | dateformat}}</p>
							</span>
							<span class="d-flex flex-column">
								<label class="font-weight-bold">Order Number:</label>
								<span class="ml-2">{{receipt_modal_data.orderNumber}}</span>
							</span>
							<span class="d-flex flex-column">
								<label class="font-weight-bold">supplier:</label>
								<span class="ml-2">{{ receipt_modal_data.supplierId | supplier(suppliers)}}</span>
							</span>
							<span class="d-flex flex-column">
								<label class="font-weight-bold">Via</label>
								<span class="ml-2">{{receipt_modal_data.via}}</span>
							</span>
						</section>
						<!-- Items sold and payments -->
						<section class="p-3 d-flex justify-content-center flex-wrap" style="height:50vh; overflow-y:scroll">
							<!-- items sold -->
							<div class="table-responsive-sm">
								<h3 class="text-muted">Items purchased</h3>
								<table class="table table-borderless">
									<thead>
										<tr>
										<th scope="col">Product</th>
										<th scope="col">Variant</th>
										<th scope="col">Qty</th>
										<th scope="col">buying Price</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product,index) in receipt_modal_data.products" :key="index">
											<td>{{product.name}}</td>
											<td>{{product.variant_id}}</td>
											<td>{{product.qty | intcomma}}</td>
											<td>{{product.buying_price | intcomma}}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<!-- payments-->
							<div class="table-responsive-sm">
									<h3 class="text-muted">Payments</h3>
									<table class="table table-borderless">
										<thead>
											<tr>
											<th scope="col">Type</th>
											<th scope="col">Transaction Id</th>
											<th scope="col">Amount</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(payment,index) in receipt_modal_data.payments" :key="index">
												<td>{{payment.type}}</td>
												<td>{{payment.transaction_id}}</td>
												<td>{{payment.amount | intcomma}}</td>
											</tr>
										</tbody>
									</table>
								</div>
						</section>

						<div></div>
					</div>
				</div>
				<div class="modal-footer">
						<span class="d-flex justify-content-between">
							<label class="font-weight-bold">Items:</label>
							<span class="ml-2">{{totalItems(receipt_modal_data.products) | intcomma}}</span>
						</span>
						<span class="d-flex justify-content-between">
							<label class="font-weight-bold">Total cost:</label>
							<span class="ml-2">{{totalCost(receipt_modal_data.products) | intcomma}}</span>
						</span>
						<span class="d-flex justify-content-between">
							<label class="font-weight-bold">Total payed:</label>
							<span class="ml-2">{{totalPayment(receipt_modal_data.payments) | intcomma}}</span>
						</span>
				</div>
			</div>
			</div>
		</div>
		<!-- add product modal -->
		<div class="modal fade" id="addProductModal" tabindex="-1" role="dialog" aria-labelledby="addProducModal" aria-hidden="true" style="z-index:99999">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header border-0">
						<h5 class="modal-title">Add Product</h5>
						<button type="button" id="closeAddProductModal" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<form id="addProductForm">
							<div class="modal-body"  style="max-height: 70vh; overflow-y: scroll">
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">Type</label>
									<label>
										<input type="radio" value="product" v-model="product_to_be_added.product_type">
										Product
									</label>
									<label>
										<input type="radio" value="service" v-model="product_to_be_added.product_type">
										Service
									</label>
								</div>
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">Name</label>
									<input type="text" class="col-8 form-control" v-model="product_to_be_added.name" required>
								</div>
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">Description</label>
									<textarea rows="3" class="col-8 form-control" v-model="product_to_be_added.description"></textarea>
								</div>
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">SKU</label>
									<input type="text" class="col-8 form-control" v-model="product_to_be_added.sku">
								</div>
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">VAT</label>
									<input type="number" class="col-8 form-control" v-model="product_to_be_added.tax">
								</div>
								<div class="p-3 d-flex justify-content-between flex-wrap">
									<label class="font-weight-bold">Units</label>
									<select class="col-8 form-control" v-model="product_to_be_added.uom_id" required>
										<option v-for="(unit,index) in units" :key="index" :value="unit.id">
											{{unit.unit}}
										</option>
									</select>
									<small class="d-flex justify-content-center col-8 text-danger" v-if="units && ! units.length">
										<p>Your shop has no units of measure added
											<br>
											this is required for adding a product
											<br>
										</p>
										<br>
									</small>
								</div>
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">Purchase price</label>
									<input type="number" class="col-8 form-control" v-model="product_to_be_added.purchase_price" required>
								</div>
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">Retail price</label>
									<input type="number" class="col-8 form-control" v-model="product_to_be_added.retail_price">
								</div>
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">wholesale price</label>
									<input type="number" class="col-8 form-control" v-model="product_to_be_added.wholesale_price">
								</div>
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">Minimum required</label>
									<input type="number" class="col-8 form-control" v-model="product_to_be_added.minimum_required" required>
								</div>
								<div class="p-3 d-flex justify-content-between">
									<label class="font-weight-bold">Initial stock</label>
									<input type="number" class="col-8 form-control" v-model="product_to_be_added.stock">
								</div>
							</div>
							<div class="modal-footer border-0">
								<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
								<button type="submit" class="btn btn-success"
									@click="addProduct()">
									Add product
									<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="adding_product"></span>
								</button>
							</div>
					</form>
				</div>
			</div>
		</div>
    </div>
</template>
<script>
import searchProducts from '@/components/searchProducts.vue'
export default {
name: 'receivePurchase',
components: {searchProducts},
props: {
	msg: String
},
data(){
	return{
        search:null,
        test: [],
        purchases:[],
        receipt_modal_data:null,
        //receive purchase
        active_basket: null,
        open_baskets:[
            {
                "id": "bask1",
                "customer": "Walk in customer",
                "products":[
                    {
                        "id": Math.floor(Date.now() / 1000),
                        "product": null,
                        "quantity": 1,
						"selection": null
                    }
                ],
            }
		],
        suppliers: null,
        locations: null,
        location:null,
        //selected supplier
        supplier:null,
        date_range:1,
        from_date: null,
		to_date: null,
        add_supplier:{
            name:null,
            phone: null,
            address:null,
            email:null,
            //state
            adding:false
        },
        //add purchase
        receipt_data:null,
		payments: {},
		purchase_successful: false,
		adding:false,
        //add product.
        units: null,
        adding_product:false,
        update_products: true,
        product_to_be_added:{
            id: null,
            product_type: 'n/a',
            name: null,
            sku: 'n/a',
            description: 'n/a',
            purchase_price: null,
            retail_price: null,
            base_selling_price: null,
            wholesale_price: null,
            minimum_required: null,
            tax: null,
            stock: null,
        },
	}
},
mounted(){
	this.from_date = this.$moment().subtract(this.date_range, 'days').format('YYYY-MM-DD')
	this.to_date = this.$moment().format('YYYY-MM-DD')
    this.getSuppliers()
    this.getLocations()
	this.active_basket = "bask1"
},
computed:{
    account_switched(){
        return this.$store.state.account_switch_count
    }
},
watch:{
    account_switched: function(){
        this.getSuppliers()
        this.getLocations()
    },
    date_range: function(){
        if (this.date_range){
            this.from_date = this.$moment().subtract(this.date_range, 'days').format('YYYY-MM-DD')
            this.to_date = this.$moment().format('YYYY-MM-DD')
            this.getPurchases()
        }
    },
    search:function(){
        this.$searchTable('purchasesTable',this.search)
    }
},
methods:{
	closeProductsModal: function(){
		var modal = document.getElementById('productsModal')
		modal.classList.add('d-none')
	},
	openProductsModal: function(){
		var modal = document.getElementById('productsModal')
		modal.classList.remove('d-none')
	},
	//get_purchases
    getUnits: function(){
        this.$http({
            method:'get',
            url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/list-units/`,
            headers:{
                Authorization: JSON.parse(localStorage.getItem('auth_token'))
            },
        }).then((response)=>{
            this.units = response.data
        }).catch((err)=>{
            this.$emit('alert',err)
        })
    },
    //receive purchase
    basket_index: function(id){
        return this.open_baskets.findIndex((basket) => basket.id === id)
    },
	productPicked:function(selected_product){
        if(selected_product != null){
			this.closeProductsModal()
			//selects active basket.
            var index = this.basket_index(this.active_basket)
            var products = this.open_baskets[index].products
            //check if product exists
            products.filter((p)=>{
                if (p.product == null){
                    //if empty then remove from list
                    products.splice(p,1)
                }
            })
			//generate id for product
            var id = Math.floor(Date.now())
			//add product to the top of the list
            products.push({
                "id": id,
                "product":selected_product.product,
				"selection": selected_product.selection
            })
            setTimeout(()=>{
                var el = document.getElementById("selectedProducts")
				el.scrollTop = el.scrollHeight
                var tr = document.getElementById(`basket-item-${id}`)
                tr.classList.add('active')
            },100)
        }
        //reset
        selected_product = null
	},
	removeProductFromBasket:function(index){
		//selects active basket.
		var basket_index = this.basket_index(this.active_basket)
		var products = this.open_baskets[basket_index].products

		products.splice(index,1)

    },
    basket_stats: function(id){
        var total = 0
        var number_of_items = 0
        var index = this.basket_index(id)
        //total
        var products = this.open_baskets[index].products
        for (var i in products){
            var product = products[i]
            if(product.product != null){
                total += parseInt(product.product.purchase_price) * product.selection.quantity
                number_of_items += parseInt(product.selection.quantity)
            }
        }
        return {"total":total,"number_of_items":number_of_items}
	},
    //get suppliers
	getSuppliers: function(){
		this.$http({
			method:'get',
			url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/suppliers/`,
			headers:{
				Authorization: JSON.parse(localStorage.getItem('auth_token'))
			},
		}).then((response)=>{
			this.suppliers = response.data
		}).catch((err)=>{
			this.$emit('alert',err)
		})
    },
    getLocations: function(){
        this.$http({
            method:'get',
            url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/locations/`,
            headers:{
                Authorization: JSON.parse(localStorage.getItem('auth_token'))
            },
            }).then((response)=>{
                this.locations = response.data
                // var current_location = JSON.parse(localStorage.getItem('logged_in_user_location_id'))
                // var location = this.locations.filter((l)=>{
                //     return l.id === current_location
                // })
                this.location = location[0]
            }).catch((err)=>{
                this.$emit('alert',err)
            })
    },
    //selectSupplier
    selectSupplier: function(supplier){
        this.supplier = supplier
    },
	selectLocation: function(location){
        this.location = location
    },
    openProcessPaymentModal:function(stats){
		this.receipt_data = stats
	},
	openReceipt: function(purchase){
		//create modal data
		this.receipt_modal_data = purchase
		//open modal
		var button = document.getElementById('receipt-modal-button')
		button.click()
	},
    organizedPurchaseData(){
		var data = {}
		var basket_index = this.basket_index(this.active_basket)
		var basket = this.open_baskets[basket_index]

		if (basket){
			//products.
			var products = []
			for (var p of basket.products){
				if (p.selection.variant){
					products.push({
						"product_id" : p.product.id,
                        "qty" : p.selection.quantity,
                        "buying_price": p.product.purchase_price,
                        "retail_price": p.product.retail_price,
                        "wholesale_price": p.product.wholesale_price,
						"total" : p.selection.price,
						"variant_id":p.selection.variant.value
					})
				}
                else{
					products.push({
						"product_id" : p.product.id,
                        "qty" : p.selection.quantity,
                        "buying_price": p.product.purchase_price,
                        "retail_price": p.product.retail_price,
                        "wholesale_price": p.product.wholesale_price,
						"total" : p.selection.price,
						"variant_id":"none"
					})
				}
			}
			data.products = products

			//payments.
			var payments = []
			if (this.payments.cash_amount){
				payments.push({
					"id": this.$randID(),
					"type": "c",
					"amount": this.payments.cash_amount,
					"transaction_id": "N/A"
				})
			}
			if (this.payments.mpesa_amount){
				payments.push({
					"id": this.$randID(),
					"type": "m",
					"amount": this.payments.mpesa_amount,
					"transaction_id": this.payments.transaction_id || "N/A"
				})
			}
			if (this.payments.credit_amount){
				payments.push({
					"id": this.$randID(),
					"type": "cr",
					"transaction_id": "N/A",
					"amount": this.payments.credit_amount,
				})
			}

			data.payments = payments
		}

		return data


	},
	//add purchase.
	makePurchase: function(){
		this.adding = true
		var organised_data = this.organizedPurchaseData()
		if (organised_data){
			this.$http({
				method: 'post',
				url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/purchase_multi_product/`,
				headers:{
					Authorization: JSON.parse(localStorage.getItem('auth_token'))
				},
				data:{
					purchase: {
						id: this.$randID(),
						date: this.$moment().format('YYYY-MM-DD'),
						supplierId: this.supplier.id,
						orderNumber: "N/A",
						via: "web",
						payments: organised_data.payments,
						products: organised_data.products,
					},
					loc_id: this.location.id
				}
			}).then(()=>{
				this.adding = false
				this.payments = {}
				this.purchase_successful =true
                this.getPurchases()
				setTimeout(()=>{
					document.getElementById('closeAddPurchasePaymentModal').click()
					this.purchase_successful = false
                    setTimeout(()=>{
                        document.getElementById('closeAddPurchaseModal').click()
                        this.removeBasket(this.active_basket)
                    },500)
				},2000)
			}).catch((err)=>{
				this.adding = false
				alert(err)
			})
		}
	},
    //add product
    addProduct: function(){
        var is_valid = document.getElementById('addProductForm').checkValidity()
        if(is_valid){
            this.adding_product = true
            this.$http({
                method:'post',
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/product/`,
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                },
                data:{
                    id: this.$randID(),
                    product_type: this.product_to_be_added.product_type || "n/a",
                    name: this.product_to_be_added.name,
                    sku: this.product_to_be_added.sku || "n/a",
                    description: this.product_to_be_added.description || "n/a",
                    purchase_price: this.product_to_be_added.purchase_price,
                    retail_price: this.product_to_be_added.retail_price || "n/a",
                    uom_id: this.product_to_be_added.uom_id,
                    base_selling_price: this.product_to_be_added.base_selling_price || "n/a",
                    img_urls: [],
                    video_url: "n/a",
                    wholesale_price: this.product_to_be_added.wholesale_price || "n/a",
                    minimum_required: this.product_to_be_added.minimum_required,
                    tax: this.product_to_be_added.tax || "0",
                    stock: this.product_to_be_added.stock || 0,
                    other_costs: [],
                    variations: [],
                    variants: [],
                    discount: "0"
                    }
            }).then(()=>{
                this.adding_product = false
                this.product_to_be_added = {
                    id: null,
                    product_type: 'n/a',
                    name: null,
                    sku: 'n/a',
                    description: 'n/a',
                    purchase_price: null,
                    retail_price: null,
                    base_selling_price: null,
                    wholesale_price: null,
                    minimum_required: null,
                    tax: null,
                    stock: null,
                }
                this.update_products = true
                document.getElementById('closeAddProductModal').click()
            }).catch((err)=>{
                this.adding_product = false
                alert(err)
            })
        }
    },
    // add supplier
    addSupplier: function(){
        var is_valid = document.getElementById('addSupplierForm').checkValidity()
        if(is_valid){
            this.add_supplier.adding = true
            this.$http({
                method:'post',
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/supplier/`,
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                },
                data:{
                    id: this.$randID(),
                    name: this.add_supplier.name,
                    address: this.add_supplier.address,
                    phone: this.add_supplier.phone,
                    email: this.add_supplier.email
                }
            }).then(()=>{
                this.add_supplier.adding = false
                this.add_supplier.name = null
                this.add_supplier.address = null
                this.add_supplier.phone = null
                this.add_supplier.email = null
                this.getSuppliers()
                document.getElementById('closeAddSupplierModal').click()
            }).catch((err)=>{
                this.add_supplier.adding = false
                alert(err)
            })
        }
    },
    // add supplier
    editSupplier: function(){
        this.add_supplier.adding = true
        this.$http({
            method:'patch',
            url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/supplier/`,
            headers:{
                Authorization: JSON.parse(localStorage.getItem('auth_token'))
            },
            data:this.supplier
        }).then(()=>{
            this.add_supplier.adding = false
            this.getSuppliers()
            document.getElementById('closeEditSupplierModal').click()
        }).catch((err)=>{
            this.add_supplier.adding = false
            alert(err)
        })
    }
}
}
</script>
